import { render } from "./WrapperPage.vue?vue&type=template&id=0d255ef7&scoped=true"
import script from "./WrapperPage.vue?vue&type=script&lang=js"
export * from "./WrapperPage.vue?vue&type=script&lang=js"

import "./WrapperPage.vue?vue&type=style&index=0&id=0d255ef7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d255ef7"]])

export default __exports__